<template>
    <i class="material-icons" :style="iconStyle">{{ getIcon }}</i>
</template>

<script>
export default {
    name: "FieldIcon",
    props: {
        type: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 18,
        },
        color: {
            type: String,
            default: null,
        },
        defaultIcon: {
            type: String,
        },
    },
    computed: {
        getIcon() {
            if (this.defaultIcon) {
                return this.defaultIcon;
            }
            switch (this.type) {
                case "text":
                case "long-text":
                    return "text_fields";
                case "number":
                    return "looks_one";
                case "currency":
                    return "attach_money";
                case "datetime":
                    return "event";
                case "dropdown":
                    return "arrow_drop_down";
                case "checkbox":
                    return "check_box";
                case "url":
                    return "link";
                case "email":
                    return "email";
                case "phone":
                    return "phone";
                case "json":
                    return "code";
                case "file":
                    return "attachment";
                case "image":
                    return "image";
                case "video":
                    return "videocam";
                case "audio":
                    return "audiotrack";
                case "color":
                    return "palette";
                case "automation-button":
                    return "smart_button";
                case "contact":
                    return "person";
                case "ticket":
                    return "confirmation_number";
                case "task":
                    return "assignment";
                case "event":
                    return "event";
                case "form-submission":
                    return "assignment_turned_in";
                case "user":
                    return "support_agent";
                case "linked-record":
                    return "switch_access_shortcut";
                case "ai":
                    return "auto_awesome";
                case "conversation":
                    return "message";
                case "record_id":
                    return "tag";
                case "record_created_at":
                    return "add_circle_outline";
                case "record_updated_at":
                    return "update";
                case "record_created_by":
                    return "person_add";
                case "record_updated_by":
                    return "person_outline";
                case "formula":
                    return "functions";
                case "lookup":
                    return "sync_alt";
                case "auto-increment":
                    return "plus_one";

                default:
                    return "help_outline";
            }
        },
        iconStyle() {
            return {
                fontSize: `${this.size}px`,
                color: this.color,
            };
        },
    },
};
</script>

<style scoped>
.material-icons {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
</style>
